import styled from "styled-components";
import React, { useState } from 'react';
import  axios from 'axios';



const ContactSection = styled.section`
  width: 100vw;
  padding: calc(2.5rem + 2.5vw) 0;
  background-color: #0a0b10;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  color: var(--white);
  display: inline-block;
  font-size: 2rem;
  margin-bottom: 3rem;
  position: relative;
  &::before {
    content: "";
    height: 1px;
    width: 50%;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0.5rem);
    /* or 100px */
    border-bottom: 2px solid var(--pink);
  }
`;

const Icons = styled.div`
  display: flex;
  margin-bottom: 3rem;
  a {
    &:hover {
      img {
        filter: invert(20%) sepia(100%) saturate(500%) hue-rotate(580deg)
          brightness(100%) contrast(97%);
      }
    }
    &:not(:last-child) {
      margin-right: 2rem;
    }
    img {
      width: 3rem;
      height: 3rem;
    }
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  input {
    padding: 1rem calc(0.5rem + 1vw);
    margin-bottom: 1rem;
    background-color: var(--nav2);
    border: none;
    border-radius: 4px;
    color: #eff7f8;
    &:active,
    &:focus {
      border: none;
      outline: none;
      background-color: var(--nav);
    }
    &::placeholder {
      color: #eff7f8;
      opacity: 0.6;
    }
    &[name="name"] {
      margin-right: 2rem;
    }
  }
  textarea {
    padding: 1rem calc(0.5rem + 1vw);
    margin-bottom: 1rem;
    background-color: var(--nav2);
    border: none;
    border-radius: 4px;
    color: #eff7f8;
    margin-bottom: 2rem;
    &:focus,
    &:active {
      background-color: var(--nav);
    }
    &::placeholder {
      color: #eff7f8;
      opacity: 0.6;
    }
  }
  button {
    padding: 0.8rem 2rem;
    background-color: var(--white);
    border-radius: 20px;
    font-size: 1.2rem;
    color: #0a0b10;
    cursor: pointer;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.1);
    }
    &:active {
      transform: scale(0.9);
    }
  }
`;

const Row = styled.div`
  @media only Screen and (max-width: 40em) {
    display: flex;
    flex-direction: column;
    input {
      &[name="name"] {
        margin-right: 0;
      }
    }
  }
`;


const Contact = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const makeRequest =(formData)=>{
    axios.post(" https://backend-dev1-vekm.onrender.com/submit-form", formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      console.log('Form submitted successfully:');
    })
    .catch(error => {
      console.error('Error submitting form:', error);
    });
    };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Form data:", formData);
      const response = await makeRequest(formData)
      console.log('Form submitted successfully:');
      setFormData({
        name: '',
        email: '',
        message: '',
        contact:'',
        companyName:''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <ContactSection id="contact">
      <Title>
        Get in Touch
</Title>
      <Form onSubmit={handleSubmit}>
        <Row>
          <input name="name" type="text" placeholder=" name " value={formData.name} onChange={handleInputChange}/>
          <input name="email" type="email" placeholder=" email id" value={formData.email} onChange={handleInputChange}/>
        </Row>
        <Row>
        <input name="contact number"  style={{ marginRight: "30px" }} type="contact number" placeholder=" contact number" value={formData.contact} onChange={handleInputChange}/>
        <input name="company name" type="company name" placeholder=" company name" value={formData.companyName} onChange={handleInputChange}/>
        </Row>
        <textarea name="message" id="message" cols="30" rows="2" placeholder="your message" value={formData.message} onChange={handleInputChange}></textarea>
        <div style={{ margin: "0 auto" }}>
          <button onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </Form>
    </ContactSection>
  );
};

export default Contact;
